import { useCallback } from 'react';
import { usePriceListDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const [priceListDelete, { isLoading }] = usePriceListDeleteMutation();

  const onRemoveConfirm = useCallback(
    (manager: { id: string | undefined }) => {
      priceListDelete({
        id: manager.id,
      })
        .then(({ data, error }: any) => {
          if (data?.success) {
            openNotificationWithIcon({
              type: 'success',
              message: `The Pricelist was successfully deleted.`,
            });
            onDeleteModalClose();
          } else if (!error.data.success) {
            const { data = {} } = error.data;
            Object.keys(data).forEach((_key: string) => {
              openNotificationWithIcon({
                type: 'error',
                message: data[_key],
              });
            });
          } else if (error.data.error) {
            openNotificationWithIcon({
              type: 'error',
              message: 'Something went wrong!',
            });
          }
        })
        .catch((err) => {
          console.log(err, 'error');
        });
    },
    [priceListDelete, openNotificationWithIcon, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
